import React from 'react';
import { FolderIcon, DocIcon, isDefaultDocIcon } from '../../../Sidebar/icons';
import { renderIcon } from '../../../SprintDetail/FlowchartView/utils/renderIcon';
import { DOC_DRAG, FOLDER_DRAG, formatDetailsDate, isAppIcon } from '../utils/browseUtils';

const ItemIcon = ({ item, size }) => {
  if (item.kind === 'folder') {
    return <FolderIcon size={size} />;
  }
  if (isDefaultDocIcon(item.doc?.icon)) {
    return <DocIcon size={size} />;
  }
  if (isAppIcon(item.doc?.icon)) {
    return renderIcon(item.doc.icon, { size: `${size}px`, fallback: <DocIcon size={size} /> });
  }
  if (typeof item.doc?.icon === 'object' && item.doc.icon.type === 'emoji' && item.doc.icon.value) {
    return <span className="docs-browse__emoji">{item.doc.icon.value}</span>;
  }
  if (typeof item.doc?.icon === 'string') {
    return <span className="docs-browse__emoji">{item.doc.icon}</span>;
  }
  return <DocIcon size={size} />;
};

const BrowseItem = ({
  item,
  view,
  iconSize,
  isDropTarget,
  copied,
  onOpen,
  onOpenInNewTab,
  onContextMenu,
  onDragOver,
  onDragLeave,
  onDrop,
}) => {
  const folder = item.kind === 'folder';
  const icon = (
    <span className="docs-browse__item-icon">
      <ItemIcon item={item} size={iconSize} />
    </span>
  );
  const name = <span className="docs-browse__item-name">{item.name}</span>;
  return (
    <button
      type="button"
      className={[
        'docs-browse__item',
        `docs-browse__item--${view}`,
        folder ? 'docs-browse__item--folder' : 'docs-browse__item--doc',
        isDropTarget ? 'docs-browse__item--drop' : '',
      ]
        .filter(Boolean)
        .join(' ')}
      draggable
      onDragStart={(e) => {
        e.dataTransfer.setData(folder ? FOLDER_DRAG : DOC_DRAG, item.id);
        e.dataTransfer.effectAllowed = 'move';
      }}
      onDragOver={folder ? (e) => onDragOver(e, item.id) : undefined}
      onDragLeave={folder ? onDragLeave : undefined}
      onDrop={folder ? (e) => onDrop(e, item.id) : undefined}
      onClick={() => onOpen(item)}
      onMouseDown={(e) => {
        if (e.button !== 1 || folder) return;
        e.preventDefault();
        e.stopPropagation();
        onOpenInNewTab?.(item);
      }}
      onContextMenu={(e) => {
        onContextMenu(e, { kind: folder ? 'folder' : 'doc', item });
      }}
      title={item.name}
    >
      {view === 'details' ? (
        <span className="docs-browse__item-main">
          {icon}
          {name}
        </span>
      ) : (
        <>
          {icon}
          {name}
        </>
      )}
      {view === 'details' && (
        <>
          <span className="docs-browse__item-date">{formatDetailsDate(item.date)}</span>
          <span className="docs-browse__item-type">{item.type}</span>
          <span className="docs-browse__item-count">
            {item.count == null ? '—' : item.count}
          </span>
        </>
      )}
      {view === 'list' && item.kind === 'folder' && (
        <span className="docs-browse__item-aside">{item.meta}</span>
      )}
    </button>
  );
};

export default BrowseItem;
